import React, { useEffect } from "react";
import { Suspense } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Spinner from "./common/Spinner/Spinner";
import RedirectComponent from "./views/RedirectPage/RedirectComponent";
import {
  MsalAuthenticationResult,
  MsalAuthenticationTemplate,
} from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "./utilities/msalAuthConfig";

const AppAdvisorPage = React.lazy(
  async () => await import("./views/AppAdvisor/AppAdvisor")
);

//redirect existing /locale/isv/... to SDC /locale/software-development-companies/...
function RedirectHandler() {
  const location = useLocation();
  const navigate = useNavigate();

  // use effect to redirect the "ISV path" to "SDC path"
  useEffect(() => {
    const { pathname, search } = location;
    // Match any locale (e.g. /en-us/, /fr-fr/, /de-de/) 
    const match = pathname.match(/^\/([^/]+)\/isv\/marketplace-app-advisor\/my-results(?:\/)?$/i);
    if (match) {
      const locale = match[1];
      const newPath = `/${locale}/software-development-companies/app-advisor/guidance/my-results`;
      navigate(`${newPath}${search}`, { replace: true });
    }
  }, [location, navigate]);

  return null;
}

function App() {
  const ErrorComponent: React.FC<MsalAuthenticationResult> = ({ error }) => {
    return (
      <div>
        An error as occurred: {error ? error.errorCode : "unknown error"}
      </div>
    );
  };

  const LoadingComponent = () => {
    return <Spinner />;
  };

  return (
    <Suspense fallback={<Spinner />}>
      {/* Global redirect handler to redirect existing url to sdc url */}
      {/* Adding only to dev and prod as PPE does not support new sdc cdn urls */}
      {process.env.REACT_APP_ANALYTICS_ENV !== "ppe" ? (
        <RedirectHandler />
      ) : null}

      <Routes>
        <Route
          path="/:locale/isv/marketplace-app-advisor/my-results"
          Component={AppAdvisorPage}
        />
        <Route
          path="/:locale/isv/marketplace-app-advisor/callback"
          element={
            <MsalAuthenticationTemplate
              interactionType={InteractionType.Redirect}
              authenticationRequest={{ ...loginRequest }}
              errorComponent={ErrorComponent}
              loadingComponent={LoadingComponent}
            >
              <RedirectComponent />
            </MsalAuthenticationTemplate>
          }
        />
        <Route
          path="/:locale/software-development-companies/app-advisor/guidance/my-results"
          Component={AppAdvisorPage}
        />
        <Route
          path="/:locale/software-development-companies/app-advisor/guidance/callback"
          element={
            <MsalAuthenticationTemplate
              interactionType={InteractionType.Redirect}
              authenticationRequest={{ ...loginRequest }}
              errorComponent={ErrorComponent}
              loadingComponent={LoadingComponent}
            >
              <RedirectComponent />
            </MsalAuthenticationTemplate>
          }
        />
      </Routes>
    </Suspense>
  );
}

export default App;
